import React from 'react';
import { TabContent, NoDataDiv } from './styles';
import { Row, Divider } from 'antd';
import { NoData } from './styles';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import PropTypes from 'prop-types';

function TabPaneCard(props) {
  const {
    tabComponent,
    tabIndex,
    filters,
    length,
    text,
    tabConfig,
    itemData,
    columnConfig,
    expandConfig,
    isLazyLoading,
    containerHeight,
    clicked
  } = props;

  switch (tabComponent) {
    case 'card':
      if (length === 0) {
        return (
          <TabContent>
            <NoDataDiv height={containerHeight}>
              <NoData>{text}</NoData>
            </NoDataDiv>
          </TabContent>
        );
      } else {
        return (
          <>
            {
              itemData.map((item, dataIndex) => {
                var configOfTab = tabConfig(item, dataIndex, () => clicked(item));
                return (
                  <>
                    <TabContent className='un-mask-div' key={dataIndex}>
                      <Row index={dataIndex} className='px3 py2'>
                        {configOfTab[tabIndex].config.map(item => item.render)}
                      </Row>
                    </TabContent>
                    <Divider
                      className={
                        dataIndex === length - 1 ? 'display-none' : 'mx3 my0 w94'
                      }
                    />
                  </>
                );
              })
            }
            {isLazyLoading ? <Preloader /> : null}
          </>
        )
      }
    case 'table':
      var configOfTab = tabConfig(
        itemData,
        columnConfig,
        expandConfig,
        filters
      );

      return (
        <>
          <TabContent>
            {length === 0 ? (
              <NoDataDiv>
                <NoData>{text}</NoData>
              </NoDataDiv>
            ) : (
              <Row>{configOfTab[tabIndex].render}</Row>
            )}
          </TabContent>
        </>
      );
    default:
      return 'Not passed component type';
  }
}

export default TabPaneCard;

TabPaneCard.propTypes = {
  activeKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.numer
  ]),
  clicked: PropTypes.func,
  isLazyLoading: PropTypes.bool,
  itemData: PropTypes.array,
  length: PropTypes.number,
  tabComponent: PropTypes.string,
  tabConfig: PropTypes.func,
  tabIndex: PropTypes.number,
  text: PropTypes.string,
}